import React, {FC} from 'react';
import {Flex} from '@priority-software/priority-style-react';
import {useImageCmp} from './hooks/useImageCmp';
import styles from '../../../styles.module.scss';
import {createDataTestId} from '../../../../../../utils/dataTestId';

export const ImageCmp: FC = () => {
    const {renderHeader, renderBody} = useImageCmp();

    return (
        <Flex
            componentClasses={styles.flexContainer}
            direction="column"
            {...createDataTestId(`email-add-image-container`, true)}
        >
            {renderHeader()}
            {renderBody()}
        </Flex>
    );
};
